var ContextMenuView = require('contextmenuview');
var FileProgressView = require('fileprogressview');
var FileList = require('filelist');


var UploadContextMenuView = ContextMenuView.extend({
    el: '#uploadContextMenu',
    initialize: function (options) {
        this.afterHide = _.bind(this.deactivateCell, this);
        ContextMenuView.prototype.initialize.call(this, options);

        this.files = new FileList(null, {session: this.model.session});

        this.progressBars = $('#uploadProgressBars');
        this.model.bind('uploadConfirmed', this.uploadConfirmed, this);
        this.model.bind('uploadSuccess', this.trimUploaded, this);
    },
    events: $.extend({}, ContextMenuView.prototype.events, {
        'buttonClick button.uploadFile': 'clickUploadFile',
        'buttonClick button.newPaste': 'clickNewPaste',
    }),
    trimUploaded: function () {
        var uploaded = this.files.filter(function (f) {
            return f.isUploaded();
        });
        if (uploaded.length > 6) {
            this.files.remove(_.last(uploaded));
            this.trimUploaded();
        }
    },
    uploadConfirmed: function (fileWrap) {
        if (!this.files.contains(fileWrap)) {
            this.files.add(fileWrap);
            var view = new FileProgressView({model: fileWrap});
            fileWrap.bind('remove', function () {
                view.remove();
            });
            this.progressBars.prepend(view.render().el);
        }
        this.trimUploaded();
    },
    clickUploadFile: function (e) {
        e.preventDefault();
        if (this.model.uploadsEnabled()) {
            this.hide();
            this.buffer.trigger('uploadPrompt');
        }
    },
    clickNewPaste: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.trigger('pastePrompt');
    },
    deactivateCell: function () {
        if (this.cell) {
            this.cell.removeClass('menuActive').attr('aria-expanded', 'false');
        }
    },
    show: function (buffer, cell) {
        this.buffer = buffer;
        this.cell = cell;
        
        this.cell.addClass('menuActive').attr('aria-expanded', 'true');
        
        this.deactivateItem(this.$('li.uploadFile'), !this.model.uploadsEnabled());
        this.$('.uploadFileDisabled').toggle(!this.model.uploadsEnabled());
        
        var offset = this.cell.offset();
        var x = offset.left + this.cell.outerWidth();
        var y = offset.top;
        
        ContextMenuView.prototype.show.call(this, x, y, {
            anchorRight: true,
            anchorBottom: true
        });
    }
});


module.exports = UploadContextMenuView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/uploadcontextmenuview.js
// module id = 6Cw2
// module chunks = 1